import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { colorsFoundation } from "../tokens/colors-foundation.js";

/**
 * CountPill — the click-dummy's "open items" indicator: a rounded pill with a
 * leading dot. When `active` (count > 0) it takes the accent tone; otherwise a
 * muted grey. Used e.g. for a Kunde's / Objekt's open-claims count.
 *
 * The accent tone reads from the primary key ramp (rose in the generic skin),
 * so the pill re-tints per brand skin.
 *
 * @param {boolean} active - Accent (true) vs muted (false) tone.
 * @param {React.ReactNode} label - Pill text, e.g. "3 offen" / "keine offen".
 */
export default function CountPill({ active, label }) {
  const tone = active
    ? {
        bg: colorsFoundation.key.blue[50],
        fg: colorsFoundation.key.blue[800],
        dot: colorsFoundation.key.blue[600],
      }
    : {
        bg: colorsFoundation.gray[100],
        fg: colorsFoundation.gray[500],
        dot: colorsFoundation.gray[400],
      };

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "3px 10px",
        borderRadius: "20px",
        fontSize: "11px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        backgroundColor: tone.bg,
        color: tone.fg,
      }}
    >
      <Box
        component="span"
        sx={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          backgroundColor: tone.dot,
          flex: "none",
        }}
      />
      {label}
    </Box>
  );
}

CountPill.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.node.isRequired,
};
